(()=>{
  // Only modal Klaviyo forms; embedded password-page signups are untouched.
  let queued=false;
  const scan=()=>{
    queued=false;
    document.querySelectorAll('form.klaviyo-form').forEach(form=>{
      let modal=form.closest('[role="dialog"],[aria-modal="true"]');
      if(!modal){let node=form.parentElement;for(let i=0;node&&i<6;i++,node=node.parentElement){if(getComputedStyle(node).position==='fixed'){modal=node;break}}}
      if(!modal)return;
      modal.classList.add('cos-klaviyo-modal');form.classList.add('cos-klaviyo-form');
      [...form.children].forEach(child=>{
        const style=getComputedStyle(child),hasImage=child.querySelector('img')||style.backgroundImage!=='none';
        if(hasImage&&!child.querySelector('input,button,a,select,textarea')&&!child.textContent.trim())child.classList.add('cos-klaviyo-art');
      });
      modal.querySelectorAll('button[aria-label]').forEach(button=>{if(/close/i.test(button.getAttribute('aria-label')))button.classList.add('cos-klaviyo-close')});
    });
  };
  const observer=new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(scan)}});
  observer.observe(document.body,{childList:true,subtree:true});scan();
})();
